// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#home_wrapper[data-v-5ddf3a57]{scroll-behavior:smooth}.fade-in-up-element[data-v-5ddf3a57]{opacity:0;transform:translateY(100px);transition:opacity 1s ease-out,transform 1s ease-out}.fade-in-up-element.is-visible[data-v-5ddf3a57]{opacity:1;transform:translateY(0)}.parallax .bg[data-v-5ddf3a57]{transition:transform .1s ease-out;will-change:transform}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
